// core
import { getCustomServerSideProps, GetServerSidePropsContext } from '@/utils/serverSide';
// views
import View from '@/views/authenticate/Login';

export default View;

export const getServerSideProps = async (
	context: GetServerSidePropsContext,
) => {
	return getCustomServerSideProps(
		context,
		{
			config: {
				layout: {
					name: 'blank',
				},
				protected: false,
			},
		},
		{
			redirectIfLogged: true,
		},
	);
};
